var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33133 7.99925C9.33138 8.17458 9.29687 8.3482 9.22977 8.51016C9.16266 8.67213 9.06429 8.81926 8.94028 8.94313L2.27837 15.6089C2.0281 15.8593 1.68865 16 1.33471 16C0.980773 16 0.641329 15.8593 0.391055 15.6089C0.140781 15.3585 0.000178548 15.0188 0.000178548 14.6647C0.000178548 14.3105 0.140781 13.9709 0.391055 13.7205L6.10697 8.00059L0.391055 2.28136C0.140604 2.03068 -6.24532e-05 1.69071 2.08009e-08 1.33625C6.24948e-05 0.981792 0.140849 0.641875 0.391388 0.391279C0.641927 0.140683 0.981696 -6.24764e-05 1.33595 2.08047e-08C1.6902 6.2518e-05 2.02992 0.140928 2.28037 0.391612L8.94228 7.05738C9.06629 7.18125 9.16466 7.32838 9.23177 7.49034C9.29887 7.65231 9.33338 7.82592 9.33333 8.00125",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron_right.8a110b28ae42d459a7ed84fe84ac5a8a.svg";
export { ForwardRef as ReactComponent };